import { FC, ReactNode } from "react";

import { FramerTooltip } from "@ryde/controls";

export const KanbanPassengerScopeRestrictionMarker: FC<{
  tooltipContent: ReactNode;
}> = ({ tooltipContent }) => (
  <FramerTooltip content={tooltipContent}>
    <span className="drag_grip drag_grip--scope-restriction">
      <span className="drag_grip-scope-restriction-dot" />
    </span>
  </FramerTooltip>
);
